import React, { useEffect } from "react"
import { LoadingComponent } from "@pga/pga-component-library"
import { redirectToMemberApplications } from "../../../lib/ptmApplicationsRedirect"

const PtmApplicationsRedirect = () => {
  useEffect(() => {
    redirectToMemberApplications()
  }, [])

  return <LoadingComponent />
}

export default PtmApplicationsRedirect
